import AnalyticsActions from "store/actions/analytics";

import { getAlarmsHistory } from "api/alarmsHistory";
import { getAnalyticsData } from "api/analytics";

import getLogger from "utils/logger.util";
import { getGraphDataPointsInterval, extractSystemId } from "utils/utils";

const Logger = getLogger("Anaytics - Thunk");

const checkTagsWithoutData = (tagsData, tagsAsObj) => {
  const tagsWithoutData = [];
  for (const tag in tagsData) {
    const tagData = tagsData[tag];
    const isTagHasData = Boolean(tagData.length);
    if (!isTagHasData) {
      const { TagId, TagName } = tagsAsObj[tag];
      tagsWithoutData.push({ TagId, TagName });
    }
  }
  return tagsWithoutData;
};

export const fetchCIPData = (smoothenData = false) => async (dispatch, getState) => {
  try {
    dispatch(AnalyticsActions.setAnlyticsTagLoading(true)); 
    const { DurationRanges, AlarmsHistory } = getState().analyticsData;
    const { tagsAsObj } = getState().tags;
    dispatch(fetchAlarmsHistory(DurationRanges, AlarmsHistory));
    const group = getGraphDataPointsInterval(DurationRanges);
    const payload = { ...DurationRanges, group };
    if (smoothenData) {
      payload.smoothenData = true;
    }
    const { data } = await getAnalyticsData(payload);
    const TagsWithoutData = checkTagsWithoutData(data.Data, tagsAsObj);
    dispatch(AnalyticsActions.setPlotData({ PlotData: data, TagsWithoutData }));
  } catch (error) {
    Logger.error("Error while fetching CIP Data..", error);
  } finally {
    dispatch(AnalyticsActions.setAnlyticsTagLoading(false));
  }
};

export const fetchAlarmsHistory = (DurationRanges, AlarmsHistory) => async dispatch => {
  try {
    if (AlarmsHistory.length === 0) {
      let analyticsActiveAlarms = [];
      const storedActiveAlarms = localStorage.getItem(`analyticsActiveAlarms${extractSystemId()}`);
      if (storedActiveAlarms) {
        analyticsActiveAlarms = JSON.parse(storedActiveAlarms);
      }
      const { data } = await getAlarmsHistory(DurationRanges);
      const alarmsHistory = data.Alarms.map(alarm => ({ ...alarm, Enable: analyticsActiveAlarms.includes(alarm.AlarmId) }));
      dispatch(AnalyticsActions.setAlarmsHistory(alarmsHistory));
    }
  } catch (err) {
    Logger.error("Error while fethcing alarm history: ", err);
  }
};

const saveActiveAlarmsInLocalStorage = alarmObjectList => {
  const storedActiveAlarms = localStorage.getItem(`analyticsActiveAlarms${extractSystemId()}`);
  let analyticsActiveAlarms = [];
  if (storedActiveAlarms) {
    const alarmList = new Set(JSON.parse(storedActiveAlarms));
    for (const { AlarmId, Enable } of alarmObjectList) {
      if (Enable) {
        alarmList.add(AlarmId);
      } else {
        alarmList.delete(AlarmId);
      }
    }
    analyticsActiveAlarms = Array.from(alarmList);
  } else {
    analyticsActiveAlarms = alarmObjectList.map(({ AlarmId }) => AlarmId);
  }
  localStorage.setItem(`analyticsActiveAlarms${extractSystemId()}`, JSON.stringify(analyticsActiveAlarms));
};

export const editAnalyticsAlarms =
  ({ Alarms, UpdatedAlarmsList }) =>
  async (dispatch, getState) => {
    const { AlarmsHistory } = getState().analyticsData;
    saveActiveAlarmsInLocalStorage(UpdatedAlarmsList);
    let updatedHistory = [...AlarmsHistory];
    UpdatedAlarmsList.forEach(updatedAlarm => {
      updatedHistory = updatedHistory.map(alarm => {
        if (alarm.AlarmId === updatedAlarm.AlarmId) {
          alarm = { ...alarm, ...updatedAlarm };
        }
        return alarm;
      });
    });

    dispatch(AnalyticsActions.saveAnalyticsAlarms({ AlarmsHistory: updatedHistory, Alarms }));
  };
